// extracted by mini-css-extract-plugin
export var cardLayout = "_76-1";
export var paginationContainer = "_76-0";